<template>
  <div>
    <BlocMainTitle
      :title="$t('assignedUsers.pageName')"
    />
    <div class="wo-container">
      <div class="wo-inner-container">
        <div class="wo-line" />
        <WorkOrderSection
          iconName="group_work"
          :showReportSection="false"
          :displayShowHideSection="false"
        >
          <template #child>
            <v-row style="margin: 0px 20px">
              <v-col
                cols="12"
                class="p-0"
              >
                <ClientAccessGroups />
              </v-col>
            </v-row>
          </template>
        </WorkOrderSection>
        <WorkOrderSection
          isLast
          iconName="person_outline"
          :showReportSection="false"
          :displayShowHideSection="false"
        >
          <template #child>
            <ClientAssignedUsers class="mb-4" />
          </template>
        </WorkOrderSection>
      </div>
    </div>
  </div>
</template>

<script>
import ClientAccessGroups from '@/views/clients/ClientAccessGroups.vue';
import ClientAssignedUsers from '@/views/clients/ClientAssignedUsers.vue';
import WorkOrderSection from '@/views/workOrders/overview/WorkOrderSection';
import BlocMainTitle from './BlocMainTitle.vue';

export default {
    components: {
        ClientAccessGroups,
        ClientAssignedUsers,
        WorkOrderSection,
        BlocMainTitle,
    },
};
</script>
